import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Submissions/PageProvider';
import { useContext } from 'react';
import {
    Button,
    Checkbox,
    Divider,
    Drawer,
    IconButton,
    Radio,
    ScrollableTableMobileSortFilters,
    Stack,
    Text,
    styled,
} from 'shell/components';
import { COLUMNS } from './Table';

const FilterDrawer = ({ sortState, handleSetSortState }) => {
    const { device } = useViewport();

    const { filters, setFilters, resetFilters } = useContext(PageContext);

    const onClose = () => {
        setFilters((current) => ({ ...current, open: false }));
    };

    const toggleStatus = (status) => {
        setFilters((current) => ({
            ...current,
            status: current.status.includes(status)
                ? current.status.filter((s) => s !== status)
                : [...current.status, status],
        }));
    };

    return (
        <Drawer anchor={'left'} device={device === 'desktop' ? 'tablet' : device} open={filters.open} onClose={onClose}>
            <Stack spacing={3}>
                <IconButton
                    sx={{ alignSelf: 'flex-end' }}
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClose}
                />

                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        Sort By
                    </Text>
                    <Button variant={'borderless'} onClick={resetFilters}>
                        Reset All
                    </Button>
                </Stack>

                <ScrollableTableMobileSortFilters
                    columns={COLUMNS}
                    sortState={sortState}
                    handleSetSortState={handleSetSortState}
                />

                <Divider />

                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    Filters
                </Text>
                <Stack spacing={2}>
                    <Text color={'light'} variant={'p1'} weight={'semibold'}>
                        Status
                    </Text>
                    <CustomStack>
                        <CustomCheckbox
                            checked={filters.status.includes('ready')}
                            label={'Ready for review'}
                            labelPlacement={'start'}
                            onChange={() => toggleStatus('ready')}
                        />
                        <CustomCheckbox
                            checked={filters.status.includes('reviewed')}
                            label={'Reviewed'}
                            labelPlacement={'start'}
                            onChange={() => toggleStatus('reviewed')}
                        />
                    </CustomStack>
                </Stack>
            </Stack>
        </Drawer>
    );
};

const CustomRadio = styled(Radio)(({ theme }) => ({
    justifyContent: 'space-between',
    '& > .MuiTypography-root': {
        color: theme.palette.ensightful.neutral[700],
    },
}));

const CustomStack = styled(Stack)(({ theme }) => ({
    paddingLeft: theme.spacing(4),
}));

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    justifyContent: 'space-between',
    '& > .MuiTypography-root': {
        color: theme.palette.ensightful.neutral[700],
    },
}));

export default FilterDrawer;
